import {configureStore} from '@reduxjs/toolkit';
import userReducer from './slice/userSlice';
import locationReducer from './slice/locationSlice';
import leadReducer from './slice/leadSlice';
import leadListPayloadReducer from './slice/leadListPayloadSlice';
import platformListPayloadReducer from './slice/platformListPayloadSlice';
import mccListValue from './slice/mccListSlice';
import saveProgressSlice from './slice/saveProgressSlice';
import filterValue from './slice/filterSlice';
import loanPayloadReducer from './slice/loanListPayloadSlice';
import dynamicFormUtilReducer from './slice/DynamicFormUtilSlice';
import rbacValueReducer from './slice/rbacSlice';
import EligibilityCheckSlice from './slice/EligibilitySlice';
import docExecutionSlice from './slice/docExecutionSlice';
import loanLogSlice from './slice/loanAppLogSlice';
import roleIdSlice from './slice/roleIdSlice';
import customerIdSlice from './slice/customerIdSlice';
import customer360PageReducer from './slice/customer360PageSlice';
import customerDetailsReducer from './slice/customerDetailsSlice';
import productFilterSlice from './slice/productFilterSlice';
import loanSearchProductSlice from './slice/loanSearchProductSlice';
const store = configureStore({
  reducer: {
    user: userReducer,
    saveProgress: saveProgressSlice,
    location: locationReducer,
    lead: leadReducer,
    leadListPayload: leadListPayloadReducer,
    platformListPayload: platformListPayloadReducer,
    mccValue: mccListValue,
    filterValue: filterValue,
    loanListPayload: loanPayloadReducer,
    dynamicFormUtil: dynamicFormUtilReducer,
    rbacValue: rbacValueReducer,
    eligibilityCheck: EligibilityCheckSlice,
    docExecution: docExecutionSlice,
    loanLogValue: loanLogSlice,
    roleIdValue: roleIdSlice,
    customerIdValue: customerIdSlice,
    customer360Page: customer360PageReducer,
    customerDetails: customerDetailsReducer,
    productFilterSlice: productFilterSlice,
    loanSearchProduct: loanSearchProductSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
